import React from "react";
import useStyles from './styles';
import { Typography } from "@material-ui/core";
import { useTranslation } from 'react-i18next';

const ErrorMessages = ({ errorString}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <div className={`${classes.formWrapper} rootFormWrapper`}>
      {errorString && (
        <Typography align="center" color="error" className={`${classes.error} error_text`}>
          {t(errorString)}
        </Typography>
      )}
    </div>
  );
};

export default ErrorMessages;
